import TriggerCard from '../TriggerCard';

export const content = ({ t }) => {
  return t('Trigger (Manual)');
};

export default function ManualTriggerCard({ type, step, ...others }) {
  return (
    <TriggerCard
      {...others}
      addMenu={false} // never show a menu
    />
  );
}
